<template>
  <modal
      :show="show"
      :title="$t('deleteAccommodationConfirmModal.title')"
      :description="$t('deleteAccommodationConfirmModal.description')"
      @save="submit"
      save-text="Confirm"
      @close="close"
      :loading="loading"
      :sticky-header="true"
      hide-top-close-button
      max-width="450"
      primary-button-class="red white--text"
  />
</template>

<script>
import Modal from '@/components/Modal.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    show: {
      required: true,
      type: Boolean,
    },
    apartmentId: {
      required: true,
    },
  },
  components: {
    Modal,
  },
  computed: {
    ...mapGetters(['loading']),
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch('loading', true);
      axios
        .post(`panel/ads/${this.apartmentId}/send-delete-accommodation-email`)
        .then(() => {
          this.$store.dispatch('message', this.$t('Accommodation deletion requested'));
          this.close();
          this.$store.dispatch('loading', false);
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            this.$store.dispatch('setErrors', error.response.data.errors);
          }
          this.close();
          this.$store.dispatch('loading', false);
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
